import React from 'react';
import CommonOperationScreen from '../../components/CommonOperationScreen/CommonOperationScreen';
import { OPERATIONS } from '../../constants';

const PaintSelect = () => {
	return (
		<CommonOperationScreen
			operationName={OPERATIONS.PAINT_SELECT}
			buttonLabel="Mark PAINT SELECT Complete"
		/>
	);
};

export default PaintSelect;
